export default "__VITE_ASSET__C$86iuHy__"